class TradeInItemList extends HTMLElement {
  constructor() {
    super();
    this.item = document.querySelector('trade-in-item').cloneNode(true);
    this.header = document.querySelector('sticky-header');
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  renderTradeInItems(tradeInItems) {
    const tradeInItemsContainer = this.querySelector('.trade-in-items-container');
    const tradeInItemEls = tradeInItems.map((item) => {
      const tradeInItem = this.querySelector('trade-in-item').cloneNode(true);
      tradeInItem.innerHTML = this.item.innerHTML
      tradeInItem.renderItem(item);
      return tradeInItem;
    });
    tradeInItemsContainer.replaceChildren(...tradeInItemEls);
  }
}

customElements.define('trade-in-item-list', TradeInItemList);
